import authentication from "./authentication";
import availability from "./availability";
import availabilityForm from "./availabilityForm";
import booking from "./booking";
import bookingAvailability from "./bookingAvailability";
import boxSpacing from "./boxSpacing";
import entityLabel from "./entityLabel";
import explore from "./explore";
import externalWidget from "./externalWidget";
import form from "./form.json";
import general from "./general";
import hbml from "./hbml.json";
import headerNavigation from "./headerNavigation";
import language from "./language";
import product from "./product";
import productDiscovery from "./productDiscovery.json";
import questionnaire from "./questionnaire.json";

const namespaces = {
    availability,
    availabilityForm,
    authentication,
    booking,
    bookingAvailability,
    general,
    headerNavigation,
    language,
    product,
    productDiscovery,
    questionnaire,
    externalWidget,
    boxSpacing,
    hbml,
    explore,
    entityLabel,
    form,
};

export default namespaces;
